module.exports = __webpack_public_path__ + "static/media/24hundred.06248058.png";